var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.7 236.54c6.07 0 11-4.83 11-10.77s-4.93-10.77-11-10.77h-17.83v21.57c0 .138-.17-.03 17.83-.03z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.43 266.57c-3.597 0-17.367 0-23.56 0v30.37c8.89-.04 19.22-.07 23.56-.07 8.51 0 15.42-6.8 15.42-15.15s-6.91-15.15-15.42-15.15z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.94 113h-395.88c-32.01 0-58.06 26.05-58.06 58.06v169.88c0 32.01 26.05 58.06 58.06 58.06h395.88c32.01 0 58.06-26.05 58.06-58.06v-169.88c0-32.01-26.05-58.06-58.06-58.06zm-332.51 213.87c-8.498 0-37.962.13-38.56.13-8.302 0-15-6.742-15-15v-112c0-8.28 6.72-15 15-15h32.83c32.07 0 51.663 35.138 34.9 62.15 32.448 27.056 13.007 79.72-29.17 79.72zm189.87-51.6c0 26.808-20.676 51.73-56.26 51.73-30.28 0-54-22.72-54-51.73v-75.27c0-8.28 6.71-15 15-15 8.28 0 15 6.72 15 15v75.27c0 12.39 10.32 21.73 24 21.73h2.26c13.68 0 24-9.34 24-21.73v-75.27c0-8.28 6.72-15 15-15 8.29 0 15 6.72 15 15zm132.45-66.8-33.06 50.78-.13 52.79c-.02 8.195-6.638 14.96-15.04 14.96-8.28-.02-14.98-6.75-14.96-15.04l.13-52.72-33.32-51.04c-4.53-6.94-2.58-16.23 4.35-20.76 6.94-4.53 16.24-2.58 20.76 4.36l23.2 35.52 22.93-35.22c4.52-6.94 13.81-8.9 20.76-4.39 6.94 4.52 8.9 13.81 4.38 20.76z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.2081bf6ae1c017e6488f432cdd66fe22.svg";
export { ForwardRef as ReactComponent };